export enum WorkFlag {
    PUBLIC_DOMAIN = 'PUBLIC_DOMAIN',
    NON_MUSICAL = 'NON_MUSICAL',
}
